import type { FC } from 'react';

import { Button } from '@wwe-portal/ui/components/button';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import type { PlayerRosterForClubStore } from '@wwe-portal/entities/roster.type';

import { BodyGrid, BodyList } from './body';

interface ResponsiveRosterCollectionProps {
  rosters?: PlayerRosterForClubStore[];
  isLoading?: boolean;
  hasUpgradeIcon?: boolean;
  onItemClick: (id: string) => void;
  total?: number;
  onViewMoreRosters?: () => void;
}

export const ResponsiveRosterCollection: FC<
  ResponsiveRosterCollectionProps
> = ({
  rosters,
  isLoading,
  onItemClick,
  onViewMoreRosters,
  total,
  hasUpgradeIcon,
}) => {
  const { isMobile } = useResponsive();
  const List = isMobile ? BodyList : BodyGrid;
  return (
    <div className="flex flex-col gap-3 md:gap-12">
      <List
        data={rosters}
        hasUpgradeIcon={hasUpgradeIcon}
        loading={isLoading}
        onItemClick={onItemClick}
      />
      {total != null && rosters != null && total > rosters.length && (
        <div className="flex w-full justify-center pt-3 md:pt-5">
          <Button
            className="h-[44px] w-full font-semibold md:w-[200px]"
            onClick={onViewMoreRosters}
            variant="secondary"
          >
            View More
          </Button>
        </div>
      )}
    </div>
  );
};
